// Iter-276.G (Top-20 #20) — Format helpers extracted from
// PartnerRateTable.jsx as part of the LoC refactor. Pure functions —
// no React, no hooks — so they're trivially unit-testable in isolation
// and free to use across the comparison-table family of components.
//
// Each function preserves its iter-184.1 / iter-185.* behavior bit-for-
// bit so existing pytests + visual snapshots stay green.

export function formatApr(min, max) {
  if (min == null && max == null) return "Varies";
  if (min == null) return `Up to ${max?.toFixed(2)}%`;
  if (max == null || max === min) return `From ${min.toFixed(2)}%`;
  return `${min.toFixed(2)}–${max.toFixed(2)}%`;
}

export function formatCredit(v) {
  return v ? `${v}+` : "—";
}

export function formatLoanRange(min, max) {
  if (!min && !max) return "—";
  const fmt = (n) => (n >= 1000 ? `$${Math.round(n / 1000)}K` : `$${n}`);
  if (min && max) return `${fmt(min)}–${fmt(max)}`;
  return min ? `From ${fmt(min)}` : `Up to ${fmt(max)}`;
}

export function formatTerm(min, max) {
  if (!min && !max) return "—";
  if (min && max) return `${min}–${max} mo`;
  return min ? `${min}+ mo` : `Up to ${max} mo`;
}

/**
 * Format an ISO timestamp as "Updated today" / "Updated Xd ago" (data-change timestamp, not an editorial review).
 * Returns null when the timestamp is missing or older than 60 days
 * (signals the row needs an editorial pass before we flaunt freshness).
 */
export function formatReviewedAgo(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const days = Math.floor((Date.now() - d.getTime()) / (1000 * 60 * 60 * 24));
  if (days < 0 || days > 60) return null;
  if (days === 0) return "Updated today";
  if (days === 1) return "Updated 1d ago";
  if (days < 14) return `Updated ${days}d ago`;
  const weeks = Math.floor(days / 7);
  return `Updated ${weeks}w ago`;
}
